import { Box, CircularProgress, Typography } from '@mui/material';
import { MessageDescriptor, useIntl } from 'react-intl';

interface FragmentDisabledTabContentProps {
  /** Same message used as the disabled tab tooltip in the header. */
  message: MessageDescriptor;
}

/**
 * Placeholder shown when the user opens a fragment tab route that is still disabled
 * (e.g. via direct URL) while media or transcription is pending.
 */
export function FragmentDisabledTabContent({ message }: FragmentDisabledTabContentProps) {
  const { $t } = useIntl();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <CircularProgress size={16} />
      <Typography variant="body2" color="text.secondary">
        {$t(message)}
      </Typography>
    </Box>
  );
}
